import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { FaWater } from 'react-icons/fa';
import { AiOutlineCar } from 'react-icons/ai';
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md'; 
import img1 from "../../../../assets/img/Services/IotEdgeSolution/55800.9755072.jpg"

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Connected City Ecosystems
            </h1>
            <p className="text-lg text-gray-600">
            Enable smart utilities, intelligent traffic management, and IoT-enabled infrastructure for smart cities.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaWater className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Smart Utilities </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Implement IoT-enabled systems for efficient monitoring and management of water, electricity, and waste systems, optimizing resource usage in smart cities.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineCar className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Intelligent Traffic & Infrastructure</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Use real-time data and IoT technology for traffic management and infrastructure monitoring, reducing congestion and improving city planning and maintenance.
              </p>
            </div>

      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}